import { SxProps } from '@mui/system'
import { Avatar } from '@vapor/material'
import { useCallback } from 'react'
import { PortalName } from 'src/api/api.generated'
import airbnb from 'src/assets/airbnb.jpg'
import booking from 'src/assets/booking.gif'
import expedia from 'src/assets/expedia.gif'
import figaro from 'src/assets/figaro_logo.gif'
import hrs from 'src/assets/hrs.gif'
import agoda from 'src/assets/agoda.gif'
import hotelbeds from 'src/assets/hotelbeds.gif'

export type PortalAvatarProps = {
  portal: PortalName
  sx?: SxProps
}

export const PortalImg = (portal: PortalName) => {
  switch (portal) {
    case PortalName.AIRBNB:
      return airbnb
    case PortalName.BOOKING:
      return booking
    case PortalName.EXPEDIA:
      return expedia
    case PortalName.AGODA:
      return agoda
    case PortalName.HOTELBEDS:
      return hotelbeds
    case PortalName.HRS:
      return hrs
    default:
      return figaro
  }
}

export const PortalAvatar = (props: PortalAvatarProps) => {
  return <Avatar variant="rounded" src={PortalImg(props.portal)} sx={{ width: '40px', height: '40px', p: 1, mr: 2, ...props.sx }} />
}
